<template>
  <div>
    <h4 v-if="title">
      {{ title }}
    </h4>

    <ul class="items">
      <li
        v-for="(item, index) in items"
        :key="index"
      >
        <zg-tile
          :href="item.href"
          :text="item.text"
          :background="background"
          full-width
        />
      </li>
    </ul>
  </div>
</template>

<script>
  import ZgTile from '../ZgTile/ZgTile'

  export default {
    name: 'ZgProductList',
    components: {
      ZgTile
    },
    props: {
      title: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        required: true,
        validator: items => Array.isArray(items) && items.length > 0 &&
          items.every(item =>
            item.text &&
            item.href
          )
      },
      background: {
        type: String,
        required: false,
        default: 'beige',
        validator: value => [
          'beige',
          'white'
        ].includes(value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .items {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin: 0 0 rhythm(small);

      &:last-child {
        margin: 0;
      }
    }
  }
</style>
